<template>
  <div class="error-wrapper">
    <figure class="error-symbol">!</figure>
    <h1 class="error-info">{{ $t('Error') }} 404</h1>
    <h2 class="error-info-additional">
      {{
        type === "number-is-not-valid" ?
          $t('Could not find 3D model of this apartment') :
          $t('Apartment URL is not valid')
      }}
    </h2>
  </div>
</template>

<script>
export default {
  name: "ErrorPage",
  props: {
    type: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/Error.scss";
</style>
